import { Button, Input, InputGroup, InputGroupText, Modal, ModalBody, ModalHeader } from "reactstrap";
import { CreateNewMessageTitle } from "../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setNewModal } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import PrivateChat from "../ChatTab/PrivateChat";

const ChatModal = () => {
  const dispatch = useAppDispatch();
  const { newModal } = useAppSelector((state) => state.messenger);
  return (
    <Modal isOpen={newModal[0]} toggle={() => dispatch(setNewModal(0))} className="fade show add-popup msg-chat-modal" centered>
      <ModalHeader>{CreateNewMessageTitle}
        <Button className="close" onClick={() => dispatch(setNewModal(0))}>
          <span>×</span>
        </Button>
      </ModalHeader>
      <ModalBody className="p-0 pt-2">
        <div className="chat-msg-search px-3">
          <InputGroup>
            <Input type="text" placeholder="Search" />
            <div className="input-group-append">
              <InputGroupText>@</InputGroupText>
            </div>
          </InputGroup>
        </div>
        <PrivateChat />
      </ModalBody>
    </Modal>
  );
};

export default ChatModal;
